import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const apiBaseURL = 'https://plasticemployers.duckdns.org'; // URL da sua API  https://plasticemployers.duckdns.org

const axiosInstance = axios.create({
    baseURL: apiBaseURL,
    headers: {
        'Content-Type': 'application/json',
    },
    withCredentials: true, // Necessário para cookies (CSRF)
});

axiosInstance.interceptors.response.use(
    (response) => response, // Retorna a resposta normalmente se for bem-sucedida
    async (error) => {
        // useNavigate não pode ser usado diretamente fora de componentes,
        // então utilize window.location para redirecionar.
        if (error.response && error.response.status === 401) {
            // Tenta renovar o token
            try {
                const refreshToken = localStorage.getItem('refresh');
                if (!refreshToken) {
                    throw new Error('Refresh token não encontrado');
                }

                const response = await axios.post(`${apiBaseURL}/api/token/refresh/`, {
                    refresh: refreshToken,
                });

                const newAccessToken = response.data.access;
                localStorage.setItem('access', newAccessToken);

                // Atualiza o header Authorization com o novo token
                axiosInstance.defaults.headers['Authorization'] = `Bearer ${newAccessToken}`;

                // Reenvia a requisição original com o novo token
                const config = error.config;
                config.headers['Authorization'] = `Bearer ${newAccessToken}`;
                return axiosInstance(config);
            } catch (refreshError) {
                console.error('Erro ao renovar o token:', refreshError);
                localStorage.clear();
                window.location.href = '/'; // Redireciona para o login
            }
        }

        return Promise.reject(error);
    }
);

export default axiosInstance;
